import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { AiRehberiPanel } from './AiRehberiPanel';
import { useRehberDurum } from './useRehber';

/**
 * Üst barda her an açılabilen "AI Rehberi" girişi.
 * Tamamlanmamış adım varsa buton üzerinde bir sayaç rozeti gösterir.
 */
export function AiRehberiButton() {
  const { t } = useTranslation('rehber');
  const [open, setOpen] = useState(false);
  const { tamamlananSayi, toplam, bitti } = useRehberDurum();
  const kalan = toplam - tamamlananSayi;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="relative inline-flex h-10 items-center gap-1.5 rounded-md border border-input bg-background px-2.5 text-sm font-medium text-muted-foreground hover:bg-muted hover:text-foreground"
        aria-label={t('ac', { defaultValue: 'AI Rehberi’ni aç' })}
        title={t('baslik', { defaultValue: 'AI Rehberi' })}
      >
        <Sparkles className="h-4 w-4 text-primary" />
        <span className="hidden sm:inline">
          {t('baslik', { defaultValue: 'AI Rehberi' })}
        </span>
        {!bitti && kalan > 0 && (
          <span className="absolute -right-1.5 -top-1.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-[11px] font-bold leading-none text-primary-foreground shadow">
            {kalan}
          </span>
        )}
      </button>

      {/* Panel yalnızca açıkken mount edilir — kapalıyken arka planda
          gereksiz müşteri-sayısı sorgusu çalışmasın. */}
      {open && <AiRehberiPanel open onClose={() => setOpen(false)} />}
    </>
  );
}
